let apirl = ''
if (process.env.NODE_ENV === 'production') {
  apirl = 'https://webgwx.irsmarket.com'
} else {
  // apirl = 'http://webapi.irsmarket.com:9999'
  apirl = 'https://webgwx.irsmarket.com'
  // apirl = 'http://localhost:9999'
  // 'https://core.irsmarket.com'
}

const CHAT_API_URL = 'https://ct.irsmarket.com:8181' // 'https://core.irsmarket.com'

export const apiurl = apirl
export const chatapi = CHAT_API_URL
